/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */
import moment from 'moment';


class UIHelperClass {
    constructor() {
    }

    showMessage(message) {
        alert(message); // eslint-disable-line no-alert
    }

    confirmAction(message) {
        //eslint-disable-next-line
        let r = confirm(message);
        return r ;
    }

    promptAction(message) {
        //eslint-disable-next-line
        let r = prompt(message);
        return r ;
    }
}

const UIHelper = new UIHelperClass();
export default UIHelper;



// WEBPACK FOOTER //
// ./src/app/library/UIHelpers.js